/**
 * An `EventTarget` subclass with typed event maps.
 */
export class TypedEventTarget extends EventTarget {
}
//# sourceMappingURL=typed-event-target.js.map